import { render, staticRenderFns } from "./ProductCostList.vue?vue&type=template&id=649743df"
import script from "./ProductCostList.vue?vue&type=script&lang=js"
export * from "./ProductCostList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports